module.exports = __webpack_public_path__ + "img/img_wuyediantai@2x.36daf685.png";